

const ContainerChart = props => {
    return (
        <div className={'chart-container ' + (props.Classe ?? '')}>
            <div className="dr-container">
                <div className="chart-title">
                    <h2 className="mb-0">{ props.title }</h2>
                </div>
            </div>
            <div className="dr-container-chart">
                { props.children }
                <ul className={"list-unstyled list-inline text-center legend " + (props.legendCSSClass ?? 'list-inline')}>
                    {props.legend.map((item, i) => {
                            return (
                                <li className={item.customCSSClass ?? "list-inline-item"} key={i}>
                                    <div>
                                        {item.color && <span className="point" style={{backgroundColor: item.color}} />}
                                        <span className="legend-note">{item.title}</span>
                                    </div>
                                </li>
                            )
                    })}
                </ul>
                <p className="note text-center note-white">{ (props.note) ? props.note : renderSource() }</p>
            </div>
        </div>
    ) 
}

const renderSource = () => {
    const l = document.getElementsByTagName('html')[0].getAttribute('lang');

    switch(l) {
        case 'en':
            return 'SOURCE: FAO, 2021c.';
        case 'es':
            return 'Fuente: FAO, 2021c.';
        case 'zh':
            return '资料来源：粮农组织，2021。';
        case 'ru':
            return 'ИСТОЧНИК: ФАO, 2021.';
        case 'ar':
            return 'المصدر: منظمة الأغذية والزراعة، 2021.';
        default:
            return 'SOURCE: FAO, 2021c.';
    }
}

export default ContainerChart;